import { isConnect } from 'utils/branding.util';
import discountSoda from './discount-soda.png';
import discount from './discount.gif';
import estrellas from './estrellas.gif';
import loaderSoda from './loader-soda.gif';
import loader from './loader.gif';

export const Animations = {
  discount,
  discountSoda,
  loader: isConnect ? loader : loaderSoda,
  estrellas,
};
